import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ConfirmationModalComponent } from '../core/components/confirmation-modal/confirmation-modal.component';
import { DialogService } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class HandleUnrecoverableStateService {
  private readonly _swUpdate = inject(SwUpdate);
  private readonly _dialogService = inject(DialogService);

  private _modalShowing = false;

  /**
   * In some cases, the version of the application used by the service worker to serve a client might
   * get into a broken state that cannot be recovered from without a full page reload.
   * For more info see:
   * https://angular.io/guide/service-worker-communications#handling-an-unrecoverable-state
   */
  handleUnrecoverableErrors() {
    if (this._swUpdate.isEnabled) {
      this._swUpdate.unrecoverable.subscribe((event) => {
        // eslint-disable-next-line
        console.error('UNRECOVERABLE ERROR: ' + event.reason);
        // eslint-disable-next-line
        console.error('Please reload the page.');

        if (!this._modalShowing) {
          const dialogRef = this._dialogService.open(ConfirmationModalComponent, {
            data: {
              message: 'An error occurred and CLEAR needs to be reloaded.',
              header: 'Reload Required',
              icon: 'pi pi-reload',
              acceptLabel: 'Reload',
            },
          });

          dialogRef.onClose.subscribe(() => {
            this._modalShowing = false;
            location.reload();
          });
        }
      });
    }
  }
}
